import { GetServerSideProps } from 'next';
import SEOHead from '../../components/SEOHead';

export default function GrafinisDizainasPage() {
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'ProfessionalService',
    name: 'Grafinis dizainas',
    description: 'Profesionalus grafinis dizainas Lietuvoje. Individualūs dizaino sprendimai, įskaitant logotipus, prekės ženklus, svetainių dizainą ir rinkodaros medžiagas verslams, siekiantiems vizualinio tapatumo.',
    provider: {
      '@type': 'Organization',
      name: 'LB Visible',
      url: 'https://www.lbvisible.com',
      knowsAbout: [
        'Grafinis dizainas',
        'Prekės ženklo tapatumas',
        'Logotipų dizainas',
        'Svetainių dizainas',
        'Rinkodaros medžiagos',
      ],
    },
    areaServed: {
      '@type': 'Country',
      name: 'Lithuania',
    },
  };

  return (
    <>
      <SEOHead
        title='Grafinis dizainas | LBVisible'
        description='Profesionalus grafinis dizainas Lietuvoje. Individualūs dizaino sprendimai, įskaitant logotipus, prekės ženklus, svetainių dizainą ir rinkodaros medžiagas verslams, siekiantiems vizualinio tapatumo.'
        keywords='grafinis dizainas, logotipų dizainas, prekės ženklo kūrimas, svetainių dizainas, rinkodaros medžiagos, grafinis dizainas Lietuvoje'
        canonicalUrl='/lt/grafinis-dizainas'
        lang='lt'
        structuredData={structuredData}
      />

      <main className='min-h-screen max-w-4xl mx-auto px-4 sm:px-6 py-12'>
        <article className='prose prose-lg dark:prose-invert max-w-none'>
          <style jsx global>{`
            article h1 {
              font-size: 2.25rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1.5rem;
              line-height: 1.2;
            }
            article h2 {
              font-size: 1.875rem;
              font-weight: 700;
              margin-top: 2rem;
              margin-bottom: 1rem;
              line-height: 1.3;
            }
            article h3 {
              font-size: 1.5rem;
              font-weight: 600;
              margin-top: 1.5rem;
              margin-bottom: 0.75rem;
              line-height: 1.4;
            }
            article p {
              margin-bottom: 1.5rem;
              line-height: 1.75;
            }
          `}</style>
          <h1 className='text-gray-900 dark:text-white'>Grafinio dizaino paslaugos</h1>
          
          <h2 className='text-gray-900 dark:text-white'>Kodėl profesionalus grafinis dizainas svarbus</h2>
          <p className='text-gray-700 dark:text-gray-400'>
            Grafinis dizainas yra jūsų verslo vizualinė kalba. Jis perduoda jūsų prekės ženklo tapatumą, 
            vertybes ir žinią jūsų tikslinei auditorijai. Profesionalus grafinis dizainas sukuria 
            įsimenamas vizualines patirtis, kurios išskiria jūsų verslą nuo konkurentų ir kuria pasitikėjimą 
            su klientais. Nesvarbu, ar jums reikia logotipo, prekės ženklo medžiagų, svetainių dizaino ar 
            rinkodaros medžiagų, profesionalus grafinis dizainas yra būtinas stipraus vizualinio buvimo, 
            kuris atitinka jūsų auditoriją, sukūrimui.
          </p>

          <h2 className='text-gray-900 dark:text-white'>Mūsų grafinio dizaino procesas</h2>
          <p className='text-gray-700 dark:text-gray-400'>
            Mūsų grafinio dizaino procesas prasideda nuo jūsų prekės ženklo, tikslinės auditorijos ir 
            dizaino tikslų supratimo. Tiriamame jūsų pramonę, analizuojame konkurentus ir kurime dizaino 
            koncepcijas, kurios atitinka jūsų prekės ženklo tapatumą ir verslo tikslus. Kurime vizualinius 
            sprendimus, kurie yra ne tik estetiškai patrauklūs, bet ir funkcionalūs bei efektyvūs perduodant 
            jūsų žinią. Visą dizaino procesą palaikome aiškų komunikaciją, teikiame reguliarų atnaujinimą 
            ir tobuliname dizainus remiantis jūsų atsiliepimais.
          </p>

          <h3 className='text-gray-900 dark:text-white'>Logotipų dizainas ir prekės ženklo tapatumas</h3>
          <p className='text-gray-700 dark:text-gray-400'>
            Kurime išskirtinius logotipus ir prekės ženklo tapatumus, kurie efektyviai atspindi jūsų verslą. 
            Mūsų logotipų dizaino paslaugos apima koncepcijos kūrimą, kelis dizaino variantus ir galutinius 
            logotipo failus įvairiais formatais. Užtikriname, kad jūsų prekės ženklo tapatumas būtų nuoseklus 
            visuose kontakto taškuose, kuriant darnią vizualinę patirtį jūsų klientams.
          </p>

          <h3 className='text-gray-900 dark:text-white'>Svetainių dizainas ir vartotojo sąsajos dizainas</h3>
          <p className='text-gray-700 dark:text-gray-400'>
            Projektuojame svetaines ir vartotojo sąsajas, kurios yra ne tik vizualiai patrauklios, bet ir 
            patogios naudoti bei orientuotos į konversiją. Mūsų svetainių dizaino paslaugos apima maketo 
            dizainą, spalvų schemas, tipografiją ir interaktyvius elementus, kurie sukuria patrauklią 
            vartotojo patirtį. Užtikriname, kad dizainai būtų atsakingi, prieinami ir optimizuoti įvairiems 
            įrenginiams ir ekrano dydžiams.
          </p>

          <h2 className='text-gray-900 dark:text-white'>Kodėl rinktis LBVisible grafiniam dizainui</h2>
          <p className='text-gray-700 dark:text-gray-400'>
            LBVisible mes suprantame, kad grafinis dizainas yra daugiau nei tik gražių vizualinių kūrimas—tai 
            verslo problemų sprendimas per dizainą. Sujungiame kūrybiškumą su strateginiu mąstymu, kad 
            pristatytume dizaino sprendimus, kurie ne tik atrodo puikiai, bet ir duoda rezultatų. Mūsų dizaino 
            požiūris orientuotas į jūsų verslo, auditorijos ir tikslų supratimą, kad sukurtume vizualinius, 
            kurie efektyviai perduoda jūsų žinią ir palaiko jūsų verslo tikslus.
          </p>

          <p className='text-gray-700 dark:text-gray-400'>
            Mūsų grafinio dizaino paslaugos apima logotipų dizainą, prekės ženklo tapatumą, svetainių dizainą, 
            rinkodaros medžiagas ir tęstinę dizaino paramą. Visą dizaino procesą dirbame glaudžiai su jumis, 
            užtikrindami, kad jūsų vizija taptų realybe ir jūsų prekės ženklas išsiskirtų rinkoje.
          </p>

          <p className='text-gray-700 dark:text-gray-400'>
            Nesvarbu, ar pradedate naują verslą, atnaujinate esamą prekės ženklą ar reikia dizaino paramos 
            rinkodaros kampanijoms, turime patirtį, kad padėtume jums sėkmės. Susisiekite su mumis šiandien, 
            kad aptartumėte savo grafinio dizaino poreikius ir sužinotumėte, kaip galime padėti jūsų verslui 
            sukurti įtikinamą vizualinį tapatumą.
          </p>
        </article>
      </main>
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    props: {},
  };
};

